import { AdditionalLoadsSchema, ModelChildLoader, ParapetLoadSchema } from '@paragon/layout-models';

export function registerParapetLoadsLoader(loaders: ModelChildLoader) {
  loaders.add(AdditionalLoadsSchema, ParapetLoadSchema, (additionalLoads) => additionalLoads.parapetManualLoadSettings);
}
